module.exports = "pegasus_template/assets/themecapture1/banner/200.png";